import styled, { css } from 'styled-components';

export const ErrorContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: center;
	padding: 20px;
	text-align: center;
`;

export const ErrorMessage = styled.div`
	color: #d32f2f;
	font-size: 16px;
	margin-bottom: 16px;
`;

export const PanelTitle = styled.div(
	({ theme }) => css`
		color: ${theme.palette.text.primary};
		font-size: ${theme.typography.bodyLargeBold.fontSize};
		font-weight: ${theme.typography.bodyLargeBold.fontWeight};
		margin-bottom: ${theme.spacing(1)};
	`,
);

export const Hint = styled.div(
	({ theme }) => css`
		color: ${theme.palette.text.secondary};
		font-size: ${theme.typography.bodyMediumRegular.fontSize};
		margin-bottom: ${theme.spacing(2)};
		max-width: 48ch;
	`,
);

export const RetryButton = styled.button`
	background: #1976d2;
	border: none;
	border-radius: 4px;
	color: white;
	cursor: pointer;
	padding: 8px 16px;

	&:hover {
		background: #1565c0;
	}
`;

export const StyledIframe = styled.iframe`
	border: none;
	height: 100%;
	width: 100%;
`;

export const IframeContainer = styled.div`
	height: 100%;
	position: relative;
	width: 100%;
`;

export const AuthOverlay = styled.div(
	() => css`
		align-items: center;
		background: rgba(255, 255, 255, 0.7);
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1000;
	`,
);

export const FloatingAuthButton = styled.button`
	align-items: center;
	background: rgba(255, 255, 255, 0.95);
	border: 1px solid #ccc;
	border-radius: 4px;
	bottom: 16px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	display: flex;
	gap: 8px;
	opacity: 0.85;
	padding: 8px 12px;
	position: absolute;
	right: 16px;
	transition: all 0.2s ease-in-out;
	z-index: 900;

	&:hover {
		opacity: 1;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	svg {
		fill: #666;
		height: 16px;
		width: 16px;
	}

	.icons {
		display: flex;
		gap: 4px;
		align-items: center;
	}

	.label {
		color: #666;
		font-size: 12px;
		font-weight: 500;
		white-space: nowrap;
	}
`;

export const ButtonRow = styled.div(
	({ theme }) => css`
		display: flex;
		gap: ${theme.spacing(1.5)};
		justify-content: center;
	`,
);
